import React, { JSX, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Trustpilotreviewcollector.css";

interface TrustpilotReviewCollectorProps {
  businessUnitId?: string;
  token?: string;
  templateId?: string;
  locale?: string;
}

declare global {
  interface Window {
    Trustpilot?: {
      loadDynamicWidget?: () => void;
      loadFromElement?: (element: HTMLElement, forceReload?: boolean) => void;
    };
  }
}

export default function TrustpilotReviewCollector({
  businessUnitId = "69b7be274fc08e8d8dd535d2",
  token = "61877c8e-f8d0-46e4-a8c3-910007ea9a1c",
  templateId = "56278e9abfbbba0bdcd568bc",
  locale = "nl-NL",
}: TrustpilotReviewCollectorProps): JSX.Element {
  const { t } = useTranslation();
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const initWidget = () => {
      if (!widgetRef.current || !window.Trustpilot) return;

      if (window.Trustpilot.loadFromElement) {
        window.Trustpilot.loadFromElement(widgetRef.current, true);
      } else if (window.Trustpilot.loadDynamicWidget) {
        window.Trustpilot.loadDynamicWidget();
      }
    };

    const existingScript = document.getElementById("trustpilot-widget-script");

    if (existingScript) {
      initWidget();
      return;
    }

    const script = document.createElement("script");
    script.id = "trustpilot-widget-script";
    script.type = "text/javascript";
    script.src =
      "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    script.onload = initWidget;

    document.head.appendChild(script);
  }, []);

  return (
    <section className="trustpilot-section" aria-label="Trustpilot reviews">
      <div className="trustpilot-container">
        <div className="trustpilot-content">
          <div className="trustpilot-widget-card">
            <h3 className="trustpilot-title">{t("trustpilot.title")}</h3>
            <p className="trustpilot-text">
              {t("trustpilot.text")}
            </p>

            <div className="trustpilot-widget-wrapper">
              <div
                ref={widgetRef}
                className="trustpilot-widget"
                data-locale={locale}
                data-template-id={templateId}
                data-businessunit-id={businessUnitId}
                data-style-height="52px"
                data-style-width="100%"
                data-token={token}
              >
                <a
                  href="https://nl.trustpilot.com/review/footballshirtmarket.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Trustpilot
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}